import { render } from "./PARTY_APPLICATION_RECEIVED.vue?vue&type=template&id=56a496ae"
import script from "./PARTY_APPLICATION_RECEIVED.vue?vue&type=script&lang=js"
export * from "./PARTY_APPLICATION_RECEIVED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__